import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-align-justify w-4 h-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", {
  x1: "3",
  x2: "21",
  y1: "6",
  y2: "6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x1: "3",
  x2: "21",
  y1: "12",
  y2: "12"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "3",
  x2: "21",
  y1: "18",
  y2: "18"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }